// extracted by mini-css-extract-plugin
export default {"button":"icon-button_button__9w-Bv","iconWrapper":"icon-button_iconWrapper__q73hh"};